import { Keyed } from "./Keyed";

export interface User extends Keyed {
  userId?: number;
  clientId: string;
  clientName?: string;
  adUserId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  mobilePhone: string;
  isSuperUser: boolean;
  employeeRoleIds: string[];
  permissions?: IPrincipalPermission[];
}
export interface NiadaUser {
  id: string;
  firstName: string;
  lastName: string;  
}

export enum PermissionSet {
  C = 1,
  R = 2,
  U = 4,
  D = 8
}
export interface IPrincipalPermission {
  id: string;
  canView: boolean;
  canUpdate: boolean;
  canCreate: boolean;
  canDelete: boolean;
}
export const MockUser: User = {
  userId: 1,
  clientId: "1",
  clientName: "Client 1",
  adUserId: "adUserId",
  employeeNumber: "employeeNumber",
  firstName: "firstName",
  lastName: "lastName",
  title: "title",
  emailAddress: "emailAddress",
  workPhone: "workPhone",
  mobilePhone: "mobilePhone",
  isLicensedUser: true,
  isActive: true,
  subscribedToFlashReports: true,
  canAccessAllReports: true,
  isVerified: true,
  userName: "userName",
  hasAcceptedLegal: true,
  isClientAdmin: true,
  isSuperUser: true,
  isLOSUser: true,
  isNIADAUser: true,
  isLOSClient: true,
  isCrmUser: true,
  organizationId: "organizationId",
  employeeRoleIds: [],
  permissions: []
}

export interface MicrosoftActiveDirectoryUser {
  displayName: string;
  givenName: string;
  jobTitle: string;
  mail: string;
  mobilePhone: string;
  officeLocation: string;
  preferredLanguage: string;
  surname: string;
  userPrincipalName: string;
  id: string;
}



// export const CreateUserPrototype: CreateUser = {
//   adUserId: '',
//   clientId: '',
//   emailAddress: '',
//   firstName: '',
//   lastName: '',
//   isLicensedUser: true,
//   isActive: true,
//   subscribedToFlashReports: false,
//   canAccessAllReports: false,
//   isVerified: false,
//   hasAcceptedLegal: false,
//   isSuperUser: false,
//   isAMSAdmin: false,
//   isLOSUser: false,  
// }